import React, { useEffect } from 'react';
import Slider from 'rc-slider';
import changeSliderLabels from '../utils/slider.label.utlis';
import SliderTooltip from './SliderTooltip';
import 'rc-slider/assets/index.css';
import { useDispatch } from 'react-redux';
import { sliderChanged } from '../actions/answers';

const QSlider = ({
  value,
  remainingPoints,
  answers,
  id,
  Eval,
  labels,
  enabledSliderLabels,
  scaleRange,
}) => {
  const dispatch = useDispatch();
  const handleChange = eventValue => {
    const valueDiff = Math.abs(value - eventValue);

    const newValue =
      remainingPoints - valueDiff >= 0 || value > eventValue ? eventValue : value + remainingPoints;

    dispatch(sliderChanged(answers, id, Eval.id, newValue));
  };

  useEffect(() => {
    handleChange(value || labels[0].value);
    const sliders = Array.from(document.getElementsByClassName('rc-slider-step'));

    if (enabledSliderLabels) {
      sliders.map(slider => {
        Array.from(slider.childNodes).map((dot, index) => {
          dot.setAttribute('slider-data-tooltip', changeSliderLabels(labels[index].value, labels));
        });
      });
    }
  }, []);

  return (
    <div className='slider'>
      <Slider
        min={labels[0].value}
        max={scaleRange}
        dots
        step={1}
        value={value}
        onChange={handleChange}
        handle={props =>
          enabledSliderLabels && (
            <SliderTooltip format={() => changeSliderLabels(value, labels)} {...props} />
          )
        }
        handleStyle={{
          backgroundColor: '#7cb342',
          border: '4px solid #7cb342',
          display: 'flex',
          justifyContent: 'center',
          height: 28,
          width: 28,
          marginTop: -9,
        }}
        dotStyle={{
          backgroundColor: '#ccc',
          border: '2px solid #ccc',
          height: 16,
          width: 16,
          bottom: -9,
        }}
        activeDotStyle={{
          backgroundColor: '#7cb342',
          border: '2px solid #7cb342',
        }}
        railStyle={{
          backgroundColor: '#ccc',
          height: 10,
        }}
        trackStyle={{
          backgroundColor: '#7cb342',
          height: 10,
        }}
      />
    </div>
  );
};

export default QSlider;
